/* eslint no-var: 0, vars-on-top: 0, one-var: 0 */
import React from 'react';
import formMixin from 'mixins/user-form-mixin';
import assign from 'object-assign';
import validationMixin from 'mixins/validationMixin';
import CustomersAPI from 'utils/CustomersAPIUtils';
import { withTranslation } from 'react-i18next';
import SessionStore from 'stores/SessionStore';
import { Alert, FormControl, Radio, FormGroup, Tooltip, OverlayTrigger, } from 'react-bootstrap';
import update from 'react-addons-update';
import { capitalize } from 'underscore.string';
import moment from 'moment/moment';
import EditableSection from 'components/v2/EditableSection';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import { getValidFormatMMDDYYYY } from 'common/helpers/dateUtils';
import { updateStateForField } from '../user-form-utils';
import AddressForm from '../address-form';
const BUSINESS_TYPES = {
    COMPANY: 'company',
    INDIVIDUAL: 'individual',
};
const BUSINESS_TYPE_SLUGS = {
    [BUSINESS_TYPES.COMPANY]: 'BUSINESS_TYPE_COMPANY',
    [BUSINESS_TYPES.INDIVIDUAL]: 'BUSINESS_TYPE_INDIVIDUAL',
};
let defaults = {
    errors: [],
    loading: false,
    type: BUSINESS_TYPES.INDIVIDUAL,
    first_name: '',
    last_name: '',
    personal_id_number: '',
    dob: {
        month: '',
        day: '',
        year: '',
    },
    business_name: '',
    business_tax_id: '',
    address: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postal_code: '',
        name: '',
    },
};
class Representative extends React.Component {
    constructor(props) {
        super(props);
        this.fetchCarrierBillingData = (carrier_id) => {
            this.setState({ loading: true });
            CustomersAPI.getBankAccounts(carrier_id)
                .then((res) => {
                const billingData = res.entity.data;
                const data = Object.assign(Object.assign({}, defaults), { type: billingData.business_type, business_name: billingData.business_profile.name, address: {
                        line1: billingData.address.line1,
                        line2: billingData.address.line2,
                        city: billingData.address.city,
                        state: billingData.address.state,
                        postal_code: billingData.address.postal_code,
                    } });
                this.setState(Object.assign({ oldData: JSON.parse(JSON.stringify(data)) }, data));
            })
                .catch((err) => {
                console.log(err.stack || err);
            })
                .finally(() => {
                this.setState({ loading: false });
            });
        };
        this.renderBillingInformationHeader = () => {
            const { t } = this.props;
            return (React.createElement("div", { className: "my-0 flex items-center justify-start" },
                React.createElement("h3", { className: "my-0 mr-1" }, t('BILLING_INFORMATION')),
                this.props.linkToStripeAccount));
        };
        this.renderBillingInformationForm = () => {
            const { t } = this.props;
            return (React.createElement("div", { className: "grid grid-cols-2 gap-x-4" },
                React.createElement(FormGroup, null,
                    React.createElement("label", { className: "form-label" }, t('FIRST_NAME')),
                    React.createElement(FormControl, { value: this.state.first_name, onChange: (e) => this.setState({ first_name: e.target.value }) })),
                React.createElement(FormGroup, null,
                    React.createElement("label", { className: "form-label" }, t('LAST_NAME')),
                    React.createElement(FormControl, { value: this.state.last_name, onChange: (e) => this.setState({ last_name: e.target.value }) })),
                React.createElement(FormGroup, { className: "col-span-2" },
                    React.createElement("label", { className: "form-label" }, t('DOB')),
                    React.createElement("div", { className: "flex" },
                        React.createElement("div", { className: "w-1/3" },
                            React.createElement(FormControl, { placeholder: "MM", value: this.state.dob.month, onChange: (e) => {
                                    e.persist();
                                    this.setState((prevState) => ({
                                        dob: Object.assign(Object.assign({}, prevState.dob), { month: e.target.value }),
                                    }));
                                } })),
                        React.createElement("div", { className: "w-1/3 px-4" },
                            React.createElement(FormControl, { placeholder: "DD", value: this.state.dob.day, onChange: (e) => {
                                    e.persist();
                                    this.setState((prevState) => ({
                                        dob: Object.assign(Object.assign({}, prevState.dob), { day: e.target.value }),
                                    }));
                                } })),
                        React.createElement("div", { className: "w-1/3" },
                            React.createElement(FormControl, { placeholder: "YYYY", value: this.state.dob.year, onChange: (e) => {
                                    e.persist();
                                    this.setState((prevState) => ({
                                        dob: Object.assign(Object.assign({}, prevState.dob), { year: e.target.value }),
                                    }));
                                } }))))));
        };
        this.renderBillingInformationSummary = () => {
            const { t } = this.props;
            return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
                React.createElement(DescriptionListItem, { label: t('FIRST_NAME') }, this.state.first_name || '-'),
                React.createElement(DescriptionListItem, { label: t('LAST_NAME') }, this.state.last_name || '-'),
                React.createElement(DescriptionListItem, { label: t('DOB'), className: "col-span-2" }, getValidFormatMMDDYYYY(moment(`${this.state.dob.year}-${this.state.dob.month}-${this.state.dob.day}`, 'YYYY-MM-DD')))));
        };
        this.renderAddressForm = () => {
            return (React.createElement("div", { className: "userDetailGroup userBillingAddress" },
                React.createElement(AddressForm, { address: this.normalizedAddress(), onChange: (address) => this.updateAddress(address) })));
        };
        this.renderAddressSummary = () => {
            const { t } = this.props;
            return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
                React.createElement(DescriptionListItem, { label: t('NAME'), className: "col-span-2" }, this.state.address.name || '-'),
                React.createElement(DescriptionListItem, { label: t('STREET_ADDRESS_1'), className: "col-span-2" }, this.state.address.line1 || '-'),
                React.createElement(DescriptionListItem, { label: capitalize(t('CITY')), className: "col-span-2" }, this.state.address.city || '-'),
                React.createElement(DescriptionListItem, { label: capitalize(t('STATE')) }, this.state.address.state || '-'),
                React.createElement(DescriptionListItem, { label: t('ZIP_CODE') }, this.state.address.postal_code || '-')));
        };
        this.onCancel = () => {
            this.setState((prevState) => {
                const data = JSON.parse(JSON.stringify(prevState.oldData));
                return Object.assign(Object.assign({}, data), { oldData: prevState.oldData });
            });
        };
        this.handleDismissAlert = () => {
            this.setState({ errors: [] });
        };
        this.renderErrors = () => {
            const { errors } = this.state;
            if (errors.length === 0) {
                return null;
            }
            return (React.createElement(Alert, { bsStyle: "danger", onDismiss: this.handleDismissAlert },
                React.createElement("ul", null, errors.map((error, i) => (React.createElement("li", { key: i },
                    error.field,
                    ": ",
                    error.error))))));
        };
        this.renderPersonalIdNumber = () => {
            const { t } = this.props;
            let name = 'personal_id_number', label = t('SSN'), errorMessage = '', error = this.props.getError(name, label);
            if (error) {
                errorMessage = React.createElement("div", { className: "userDetailError" }, error);
            }
            return (React.createElement(FormGroup, null,
                React.createElement("label", { className: "form-label" }, label),
                React.createElement(FormControl, { maxLength: "12", "data-validation": this.props.getFieldValidation(name), type: "text", className: "userSSN", name: name, placeholder: "XXX-XX-XXXX", value: this.state.personal_id_number, onChange: (e) => {
                        this.setState({ personal_id_number: e.target.value });
                    } }),
                errorMessage));
        };
        this.renderBusinessTypeSummary = () => {
            const { t } = this.props;
            return (React.createElement("div", { className: "flex flex-col gap-4" },
                React.createElement(DescriptionListItem, { label: t('BUSINESS_TYPE') }, t(BUSINESS_TYPE_SLUGS[this.state.type])),
                this.state.type === BUSINESS_TYPES.COMPANY && (React.createElement(React.Fragment, null,
                    React.createElement(DescriptionListItem, { label: t('COMPANY_NAME') }, t(this.state.business_name) || '-'),
                    React.createElement(DescriptionListItem, { label: t('EIN') }, t(this.state.business_tax_id) || '-'))),
                this.state.type === BUSINESS_TYPES.INDIVIDUAL && (React.createElement(DescriptionListItem, { label: t('SSN') }, t(this.state.personal_id_number) || '-'))));
        };
        this.renderBusinessTypeForm = () => {
            const { t } = this.props;
            const CompanyTooltip = (React.createElement(Tooltip, { id: "tooltip-company-required-details" }, t('LEGAL_ENTITY_VERIFICATION')));
            const IndividualTooltip = (React.createElement(Tooltip, { id: "tooltip-individual-required-details" }, t('PERSON_IDENTIFICATION')));
            return (React.createElement("div", { className: "flex flex-col" },
                React.createElement(FormGroup, null,
                    React.createElement("label", { className: "form-label" }, t('BUSINESS_TYPE')),
                    React.createElement(OverlayTrigger, { placement: "top", overlay: CompanyTooltip },
                        React.createElement("div", { className: "userDetailValue" },
                            React.createElement(Radio, { checked: this.state.type === BUSINESS_TYPES.COMPANY, name: "type", id: "user_type_company", value: BUSINESS_TYPES.COMPANY, onChange: this.onTypeChange, inline: true }, t(BUSINESS_TYPE_SLUGS[BUSINESS_TYPES.COMPANY])))),
                    React.createElement(OverlayTrigger, { placement: "top", overlay: IndividualTooltip },
                        React.createElement("div", { className: "userDetailValue" },
                            React.createElement(Radio, { checked: this.state.type === BUSINESS_TYPES.INDIVIDUAL, onChange: this.onTypeChange, value: BUSINESS_TYPES.INDIVIDUAL, id: "user_type_individual", inline: true }, t(BUSINESS_TYPE_SLUGS[BUSINESS_TYPES.INDIVIDUAL]))))),
                this.state.type === BUSINESS_TYPES.COMPANY && (React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, null,
                        React.createElement("label", { className: "form-label" }, t('COMPANY_NAME')),
                        React.createElement(FormControl, { value: this.state.business_name, onChange: (e) => updateStateForField(e, 'business_name', this) })),
                    React.createElement(FormGroup, null,
                        React.createElement("label", { className: "form-label" }, t('EIN')),
                        React.createElement(FormControl, { value: this.state.business_tax_id, onChange: (e) => updateStateForField(e, 'business_tax_id', this) })))),
                this.state.type === BUSINESS_TYPES.INDIVIDUAL &&
                    this.renderPersonalIdNumber()));
        };
        this.updateAddress = (address) => {
            const updatedAddress = {
                city: address.city,
                line1: address.street,
                postal_code: address.zipcode,
                state: address.state,
                name: address.name,
            };
            this.setState((prevState) => update(prevState, { $merge: { address: updatedAddress } }));
        };
        this.normalizedAddress = () => {
            const address = this.state.address;
            return {
                city: address.city,
                street: address.line1,
                zipcode: address.postal_code,
                state: address.state,
                name: address.name,
            };
        };
        this.onTypeChange = (e) => {
            let value = e.target.value;
            this.setState({ type: value });
        };
        this.onSave = (e) => {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            let me = this, errors = this.props.getValidationErrors();
            // Check company fields
            if (this.state.type === 'company') {
                ['business_name', 'business_tax_id'].forEach(function (field) {
                    if (!me.state[field]) {
                        errors.push({
                            field: field,
                            value: me.state[field],
                            error: 'Required for companies.',
                        });
                    }
                });
            }
            this.setState({ errors: errors });
            const value = assign({}, this.state, { errors: errors });
            delete value.oldData;
            if (this.props.onSave) {
                const success = this.props.onSave(value);
                if (success) {
                    this.setState({ oldData: JSON.parse(JSON.stringify(value)) });
                }
                return success;
            }
            return !errors.length;
        };
        let legalEntity = {};
        this.state = assign(defaults, legalEntity);
    }
    componentDidMount() {
        this.fetchCarrierBillingData(this.props.carrier_id);
    }
    render() {
        const { t } = this.props;
        return (React.createElement(EditableSection, { title: this.renderBillingInformationHeader(), canEdit: !this.state.loading && SessionStore.hasFinanceAdminRole(), onCancel: this.onCancel }, (editing, saving, onSaveSuccess, onSaveFailed) => {
            if (saving) {
                const success = this.onSave();
                if (success) {
                    onSaveSuccess();
                }
                else {
                    onSaveFailed();
                }
            }
            if (this.state.loading) {
                return t('LOADING');
            }
            return (React.createElement(React.Fragment, null,
                this.renderErrors(),
                !editing && this.renderBillingInformationSummary(),
                editing && this.renderBillingInformationForm(),
                React.createElement("hr", null),
                React.createElement("h3", { className: "mb-4" }, t('COMPANY_INFO')),
                !editing && this.renderBusinessTypeSummary(),
                editing && this.renderBusinessTypeForm(),
                React.createElement("hr", null),
                React.createElement("h3", { className: "mb-4" }, t('BILLING_ADDRESS')),
                !editing && this.renderAddressSummary(),
                editing && this.renderAddressForm()));
        }));
    }
}
export default withTranslation()(formMixin(validationMixin(Representative)));
